import { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import PropTypes from 'prop-types';
import { dismissToast } from 'ducks/modules/toaster';
import constants from 'utils/constants';
import Icon from 'components/icon/icon';
import 'components/toaster/toaster.scss';

class Toaster extends Component {
    nodeRefs = new Map();

    getNodeRef(key) {
        if (!this.nodeRefs.has(key)) {
            this.nodeRefs.set(key, createRef());
        }
        return this.nodeRefs.get(key);
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (this.props.toaster !== props.toaster && props.toaster.length > 0 && props.toaster[0]) {
            if (!props.toaster[0].hasOwnProperty('expirer') && props.toaster[0].title) {
                props.toaster[0].expirer = setTimeout(
                    () => this.props.dismissToast(props.toaster[0].title),
                    props.toaster[0].expires || constants.ToastDurations.DEFAULT,
                );
            }
        }
    }

    render() {
        return (
            <ul className="bk-toaster">
                <TransitionGroup>
                    {this.props.toaster &&
                        this.props.toaster.length > 0 &&
                        this.props.toaster.map((toast, i) => {
                            const nodeRef = this.getNodeRef(`toast-${i}`);
                            return (
                                <CSSTransition
                                    key={`toast-${i}`}
                                    nodeRef={nodeRef}
                                    classNames="toast"
                                    timeout={{ enter: 2000, exit: 2000 }}>
                                    <li ref={nodeRef} className={toast.type}>
                                        {toast.title}
                                        {toast.actions &&
                                            toast.actions.map((action) => (
                                                <a
                                                    className="action"
                                                    onClick={(e) => {
                                                        this.props.dismissToast(toast.title);
                                                        action.action(e);
                                                    }}>
                                                    {action.label}
                                                </a>
                                            ))}
                                        <Icon onClick={() => this.props.dismissToast(toast.title)} icon="x" />
                                    </li>
                                </CSSTransition>
                            );
                        })}
                </TransitionGroup>
            </ul>
        );
    }
}

const mapStateToProps = (state) => ({
    toaster: state.toaster,
});

const mapDispatchToProps = (dispatch) => ({
    dismissToast: (title) => dispatch(dismissToast(title)),
});

Toaster.propTypes = {
    toaster: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            type: PropTypes.string,
            expirer: PropTypes.func,
            expires: PropTypes.number,
            actions: PropTypes.arrayOf(
                PropTypes.shape({
                    label: PropTypes.string,
                    action: PropTypes.func,
                }),
            ),
        }),
    ),
    dismissToast: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(Toaster);
